import React from 'react';

import { Button, Icon } from '@iq/react-components';
import { useSelector } from 'react-redux';
import { getIsContributorOrAdmin } from '../../../../../bundles/auth';
import { getActiveSite } from '../../../../../bundles/sites';

const ItemHandler = ({ move, index, count, duplicatePages, showDuplicateIcon }) => {
  const site = useSelector(getActiveSite);
  const isContributorOrAdmin = useSelector((state) => getIsContributorOrAdmin(state, site));

  const handleButton = () => {
    duplicatePages(index);
  };
  return (
    <div className="move-item-component">
      <Button
        disabled={index - 1 < 0}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          move(index, index - 1);
        }}
        activity="secondary"
        icon={<Icon icon="he-up" />}
        slim
      />
      <Button
        disabled={index + 1 > count - 1}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          move(index, index + 1);
        }}
        activity="secondary"
        icon={<Icon icon="he-down" />}
        slim
      />
      {isContributorOrAdmin && showDuplicateIcon && (
        <Button
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleButton();
          }}
          activity="secondary"
          icon={
            <Icon
              icon="he-duplicate"
              size="s"
            />
          }
          slim
        />
      )}
    </div>
  );
};

export default ItemHandler;
